import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  focusCreated: {
    id: 'focus.modal.toast.created',
    defaultMessage: 'Focus created',
  },
  focusUpdated: {
    id: 'focus.modal.toast.updated',
    defaultMessage: 'Focus updated',
  },
  focusDeleted: {
    id: 'focus.modal.toast.deleted',
    defaultMessage: 'Focus deleted',
  },
});
